import React from 'react';
import st from './style.module.scss';
import { Button } from 'antd';
import { useTranslation } from 'react-i18next';
import CompanyLogo from './CompanyLogo';
import { enUS, ru, uz } from 'date-fns/locale';
import { format } from 'date-fns';

const VacancyCard = ({ actualData }) => {
  const limitedData = actualData?.slice(0, 6);

  return (
    <>
      {limitedData?.length && (
        <>
          {limitedData.map(item => (
            <CardComponent item={item} />
          ))}
        </>
      )}
    </>
  );
};

export default VacancyCard;

export const CardComponent = ({ item }) => {
  const { t, i18n } = useTranslation();
  const dateLocale = {
    en: enUS,
    ru: ru,
    uz: uz,
  };
  const currentLanguage = dateLocale[i18n.language] || dateLocale.en;
  const uploadedDate = new Date(item?.createdAt);
  const formatPattern = i18n.language === 'en' ? 'MMMM d, yyyy' : 'd MMMM yyyy';
  const formattedText = format(uploadedDate, formatPattern, {
    locale: currentLanguage,
  });
  const formatter = new Intl.NumberFormat('ru-RU');
  return (
    <div key={item?.id} className={st.cardContainer}>
      <div className={st.cardWrapper}>
        <div className={st.cardHeader}>
          <p className={st.headerWatching}>
            {t('watching')} {item?.viewedAmount} {t('timeWord')}
          </p>
          <h3 className={st.cardHeaderTitle}>{item?.name}</h3>
          <p className={st.cardHeaderSalary}>
            {item?.salary === 0 ? (
              t('free')
            ) : (
              <span>
                {formatter.format(item?.salary)}
                <span className="currency">so'm {t('forMonth')}</span>
              </span>
            )}
          </p>
        </div>
        <div className={st.cardContentWrapper}>
          <div className={st.cardContentBadge}>
            <span className={st.cardContentBadgeText}>{item?.positionName}</span>
            <span className={st.cardContentBadgeText}>{item?.jobType}</span>
          </div>
          <div className={st.cardContentCompany}>
            <div className={st.cardCompany}>
              <span>{item?.companyName}</span>
              <span className={st.companyAddress}>{item?.addressName}</span>
            </div>
            <div className={st.companyLogo}>
              <CompanyLogo logo={item?.logo} companyName={item?.companyName} />
            </div>
          </div>
        </div>
        <div className={st.cardFooter}>
          <Button
            onClick={() => {
              window.open(
                `https://m-career.uwed.uz/job/${item?.id}?lng=${currentLanguage}`,
                '_blank',
              );
            }}
            className={st.cardFooterBtn}
          >
            {t('apply')}
          </Button>
          <span>
            {t('uploaded')}: {formattedText}
          </span>
        </div>
      </div>
    </div>
  );
};
